import { camelCase as camelCaseOriginal } from 'change-case'

export const camelCase = camelCaseOriginal
